import Layout from '@/components/layout';
import Theme from '@/components/template/Theme';
import { ConfigProvider } from '@/configs/ConfigProvider';
import 'devextreme/dist/css/dx.light.css';
import React, { useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import history from './history';
import './locales';
import store, { persistor } from './store';

const AppContent = () => {
  const [css, setCss] = useState('');

  const handleChange = (e) => {
    setCss(e.target.value);
  };

  const handleApply = () => {
    const style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  };

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter history={history}>
          <HelmetProvider>
            <Theme>
              <Layout />
            </Theme>
          </HelmetProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

function App() {
  return (
    <ConfigProvider>
      <AppContent />
    </ConfigProvider>
  );
}

export default App;
